import React, { useState, useEffect, useContext } from "react";
import MonStyle from "./EditionRappel.module.css";
import SurfaceBloc from "../../../../../Design/Surfaces/SurfaceBloc";
import InputSwitch from "../../../../../Design/Formulaires/Switch";
import InputTexte from "../../../../../Design/Formulaires/InputTexte";
import SmsIcon from "@material-ui/icons/Sms";
import EmailIcon from "@material-ui/icons/Email";
import { Divider } from "@material-ui/core";
import MessageAide from "../../../../../Design/Messages/MessageAide";
import BlocRappel from "./BlocRappel";
import { MessagesContext } from "../../../../../Data/MessagesContext";
import ObjetSms from "../../../../../Design/Objets/ObjetSms";
import AffichageConditionnel from "../../../../../Design/DataDisplay/AffichageConditionnel";
import { pluriel } from "../../../../../functions/Formatter";
import { AgendasContext } from "../../../../../Data/AgendasContext";
export default function EditionRappel({
  agenda_id,
  monRdv,
  onMailConfirmationChange,
  onTelephoneConfirmationChange,
  onClick,
  emailConfirmation,
  telephoneConfirmation,
  mode,
  isSuppression,
  sousTitre,
  titre,
  codeSuppression,
  texteEmailConfirmation = "",
  onTexteEmailConfirmationChange,
}) {
  //NES gestion du state
  const [isMail, setIsMail] = useState(false);
  const [isSms, setIsSms] = useState(false);
  const [numeroPortable, setNumeroPortable] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [listeSms, setListeSms] = useState([]);

  // Le volet d'édition partage les choix du volet principal.
  const choixControles = mode !== "AFFICHAGE" && emailConfirmation !== undefined;
  const mailActif = choixControles ? Boolean(emailConfirmation) : isMail;
  const smsActif = choixControles ? Boolean(telephoneConfirmation) : isSms;

  //NES gestion du contexte
  const { getRdvSms } = useContext(MessagesContext);
  const { agendaById } = useContext(AgendasContext);

  //USEEFFECT récupération des sms envoyés
  useEffect(() => {
    if (monRdv?._id) {
      getRdvSms(monRdv?._id).then((reponse) => {
        if (reponse.code === "OK") {
          setListeSms(reponse.data);
        }
      });
    }
    // eslint-disable-next-line
  }, [monRdv?._id]);

  //USEEFFECT
  useEffect(() => {
    if (choixControles) {
      setEmail(monRdv?.patient?.patient_email || "");
      const portables = monRdv?.patient?.patient_contact?.telephones || [];
      setNumeroPortable(portables.find((item) => item.is_portable)?.numero || "");
      return;
    }
    //NES est ce que j'ai une adresse email?
    if (monRdv?.patient?.patient_email) {
      setEmail(monRdv?.patient?.patient_email);
      setIsMail(true);
    } else {
      setEmail("");
      setIsMail(false);
    }

    //NES est-ce que j'ai un numéro de téléphone portable?
    let liste = monRdv?.patient?.patient_contact?.telephones;
    let tempNumeroPortable = "";
    if (liste) {
      liste = liste.filter((item) => item.is_portable === true);

      if (liste.length >= 1) {
        tempNumeroPortable = liste[0].numero;
        setNumeroPortable(tempNumeroPortable);
        setIsSms(true);
      } else {
        setNumeroPortable("");
        setIsSms(false);
      }
    }

    //NES si le rdv est inférieur à la date du jour quand je le créé
    if (!isSuppression && !monRdv._id) {
      const aujourdhui = new Date();
      const dateRdv = new Date(monRdv.date_heure);
      if (dateRdv < aujourdhui) {
        setMessage(
          "La date du rendez vous est inférieure à la date et heure du jour, par défaut aucune confirmation n'est envoyée."
        );
        setIsSms(false);
        setIsMail(false);
      }
    }

    //NES est que j'ai coché le rappel dans l'agenda?
    let monAgenda = agendaById(agenda_id);
    if (monAgenda?.sms?.is_sms_rappel_rdv === false) {
      setIsSms(false);
    }
    if (monAgenda?.email?.is_email_rappel_rdv === false) {
      setIsMail(false);
    }

    // eslint-disable-next-line
  }, [monRdv, choixControles]);

  //USEEFFECT
  useEffect(() => {
    if (codeSuppression) {
      setIsSms(true);
      setIsMail(true);
    }

    if (codeSuppression === "DELETE") {
      setIsSms(false);
      setIsMail(false);
    }
  }, [codeSuppression]);

  ///handleSwitchMail
  const handleSwitchMail = () => {
    if (choixControles) {
      onMailConfirmationChange(mailActif ? "" : email);
    } else {
      setIsMail(!isMail);
    }
  };

  ///handleSwitchSms
  const handleSwitchSms = () => {
    if (choixControles) {
      onTelephoneConfirmationChange(smsActif ? "" : numeroPortable);
    } else {
      setIsSms(!isSms);
    }
  };

  //USEEFFECT Remonté du mail si actif
  useEffect(() => {
    if (!choixControles && onMailConfirmationChange) {
      if (isMail) {
        onMailConfirmationChange(email);
      } else {
        onMailConfirmationChange("");
      }
    }

    // eslint-disable-next-line
  }, [isMail, email, choixControles]);

  //USEEFFECT Remonté du téléphone portable si actif
  useEffect(() => {
    if (!choixControles && onTelephoneConfirmationChange) {
      if (isSms) {
        onTelephoneConfirmationChange(numeroPortable);
      } else {
        onTelephoneConfirmationChange("");
      }
    }

    // eslint-disable-next-line
  }, [isSms, numeroPortable, choixControles]);

  const champTexteEmail = !isSuppression && onTexteEmailConfirmationChange && (
    <InputTexte
      label="Texte personnalisé pour cet email"
      value={texteEmailConfirmation}
      onChange={(event) =>
        onTexteEmailConfirmationChange(event.target.value.slice(0, 1000))
      }
      multiline
      minRows={4}
      inputProps={{ maxLength: 1000 }}
      placeholder="Recommandations, lien vers l'espace du patient…"
      helperText={`${texteEmailConfirmation.length}/1000 caractères — uniquement pour cet email`}
      style={{ marginTop: "15px", marginBottom: "15px" }}
    />
  );

  //NES mes useEffect ne se déclenchait pas car le composant n'était pas affiche du coup pour gérer mes règles 1x je fais 2 retours différents
  if (mode === "AFFICHAGE") {
    return (
      <>
        <BlocRappel
          onClick={onClick}
          emailConfirmation={emailConfirmation}
          telephoneConfirmation={telephoneConfirmation}
          badgeContent={listeSms.length}
        />
        {emailConfirmation && champTexteEmail}
      </>
    );
  }

  return (
    <div className={MonStyle.EditionRappel}>
      <MessageAide
        message={message}
        disableClose
        style={{ marginBottom: "30px" }}
      />
      <h3>{titre}</h3>
      <p>{sousTitre}</p>

      <SurfaceBloc>
        <div className={MonStyle.Bloc}>
          <EmailIcon
            value={mailActif}
            className="IconeObjet"
            style={{ color: mailActif ? "#0FA600" : "#DDD" }}
          />
          <InputSwitch
            onClick={handleSwitchMail}
            label={email ? "Email de confirmation" : "Email non renseigné"}
            description={email}
            value={mailActif}
            onChange={handleSwitchMail}
            style={{ margin: 0, width: "100%" }}
            disabled={email ? false : true}
          />
        </div>
        {mailActif && champTexteEmail && (
          <div style={{ padding: "0 15px" }}>{champTexteEmail}</div>
        )}
        <Divider />
        <div className={MonStyle.Bloc}>
          <SmsIcon
            value={smsActif}
            className="IconeObjet"
            style={{ color: smsActif ? "#0FA600" : "#DDD" }}
          />
          <InputSwitch
            value={smsActif}
            onClick={handleSwitchSms}
            label={
              numeroPortable
                ? "Sms de confirmation"
                : "Aucun numéro de portable"
            }
            description={numeroPortable}
            onChange={handleSwitchSms}
            style={{ margin: 0, width: "100%" }}
            disabled={numeroPortable ? false : true}
          />
        </div>
      </SurfaceBloc>

      <AffichageConditionnel open={!isSuppression}>
        <div className={MonStyle.SmsEnvoyes}>
          <h3>{pluriel(listeSms.length, "sms envoyé", "sms envoyés")}</h3>
          <div className={MonStyle.ListeSmsEnvoyes}>
            {listeSms.map((sms) => (
              <ObjetSms sms={sms} />
            ))}
          </div>
        </div>
      </AffichageConditionnel>
    </div>
  );
}
